export const SET_DEALERS_FILTERS = 'SET_DEALERS_FILTERS';

export const setDealersFilters = ({ searchText, company, status }) => ({
    type: SET_DEALERS_FILTERS,
    payload: {
        searchText,
        company,
        status
    }
});
